import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * Confirmation shown before deleting a link.
 * We deliberately keep this small — one clear question, one destructive
 * button, one escape hatch.
 */
export default function DeleteConfirm({ link, onClose, onConfirm }) {
  const open = !!link;
  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onClose()}>
      <AlertDialogContent
        data-testid="delete-confirm"
        className="border-white/10 bg-[#101012] text-text-main"
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display tracking-tight">
            Delete “{link?.name}”?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-text-muted">
            This removes the link and every daily count recorded for it.
            You cannot undo this.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            data-testid="delete-cancel"
            className="border-white/10 bg-transparent text-text-main hover:bg-white/5"
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="delete-confirm-btn"
            onClick={onConfirm}
            className="bg-red-600/80 text-white hover:bg-red-600"
          >
            Delete link
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
